import type { RevenueRow } from './revenue-types';

/**
 * Margin on the money kept: net of refunds, less the measured processing cost, as a percent of net. Null
 * when nothing was collected: there is no margin on no revenue, and a red "0%" on twenty test companies
 * said otherwise.
 */
export function margin(r: { net: number; cost: number }): number | null {
  return r.net <= 0 ? null : ((r.net - r.cost) / r.net) * 100;
}

/** Processing cost over the pages read; null when none were read. */
export function costAPage(r: Pick<RevenueRow, 'cost' | 'pagesRead'>): number | null {
  return r.pagesRead > 0 ? r.cost / r.pagesRead : null;
}

/** Where a table that shows `limit` rows from `offset` of `total` stands: "1–50 of 312", and its neighbours. */
export function pageOf(page: { offset: number; limit: number; total: number; shown: number }) {
  const first = page.total === 0 ? 0 : page.offset + 1;
  const last = page.offset + page.shown;
  return {
    first,
    last,
    previous: page.offset > 0 ? Math.max(0, page.offset - page.limit) : null,
    next: last < page.total ? page.offset + page.limit : null,
  };
}
